import ContentDescription from '@components/partials/common/contentDescription';
import classes from '@styles/scss/site/cardRating.module.scss';

import RatingButton from './rating/ratingButton';
import RatingImage from './rating/ratingImage';
import RatingSiteBox from './rating/ratingSiteBox';
import RatingSiteDescription from './rating/ratingSiteDescription';
import RatingStars from './rating/ratingStars';

export default function SiteCardRating({
    siteCardRating,
    siteLink,
    categoryName,
    buttonText
}: {
    siteCardRating: any;
    siteLink: string;
    categoryName: string;
    buttonText: string;
}): JSX.Element {
    const pros = [siteCardRating.pro1, siteCardRating.pro2, siteCardRating.pro3];
    const cons = [siteCardRating.con1, siteCardRating.con2, siteCardRating.con3];
    return (
        <>
            <div className={classes.siteDetails} data-pint-1321="setToNone">
                <RatingImage
                    siteLink={siteLink}
                    image={siteCardRating.image}
                    categoryName={categoryName}
                    siteName={siteCardRating.name}
                />
                <div className={classes.siteLeft}>
                    <RatingStars siteReviewData={siteCardRating} />
                    <RatingButton
                        siteLink={siteLink}
                        categoryName={categoryName}
                        siteName={siteCardRating.name}
                        buttonText={buttonText}
                    />
                </div>
                <div className={classes.siteRight}>
                    <RatingSiteBox pros={pros} cons={cons} />
                    <RatingSiteDescription bottomLine={siteCardRating.bottomLine} />
                </div>
            </div>
        </>
    );
}
